import {
  initialState,
  Actions,
  State,
  NEW_COMMENT,
  NEW_COMMENT_SUCCESS,
  NEW_COMMENT_ERROR,
  RESET_NEW_COMMENT,
} from '../../types/comment/new-comment';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_COMMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_COMMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_COMMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_COMMENT:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
